<app-consent-header></app-consent-header>
<div class="content case-content astro font-maxis-regular">
  <app-loading-bar></app-loading-bar>
  <div class="apt-container">
    <div class="apt-grid filters mb-0 row">
      <div class="apt-container row">
        <div class="status-container">
          <div class="status-icon" [ngClass]="statusConfig[status].color">
            <i [class]="statusConfig[status].icon"></i>
          </div>

          <div class="status-title" [ngClass]="statusConfig[status].color">
            {{ title }}
          </div>

          <div class="status-message">
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-consent-footer></app-consent-footer>
</div>
